import { IconProps } from ".";
import Icon from "./assets/view_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24View(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
